import { useAuth0 } from '@auth0/auth0-react'
import { GLoading } from 'components/basic-blocks'
import { useStores } from 'hooks'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Users } from 'services/user'
import { parseError } from 'utils/errors'
import { getPendingInviteCode } from 'utils/invite-storage'
import { ConfirmUserState } from './types'
import { ConfirmUserView } from './view'

export const ConfirmUserPage = () => {
	const { isAuthenticated, loginWithRedirect } = useAuth0()
	const { userStore, accountStore } = useStores()
	const { accounts } = accountStore
	const { user } = userStore

	const navigate = useNavigate()
	const { f } = useParams()

	const isEmailLike = (s: string) => typeof s === 'string' && s.includes('@')
	const initialName = user?.name && !isEmailLike(user.name) ? user.name : ''

	const [state, setState] = useState<ConfirmUserState>({
		name: initialName,
		phone_number: user?.phone_number?.replace(/\+/g, '') || '',
		timezone: user?.timezone,
		country: user?.country,
		loading: false,
		error: null,
		step: 'confirmation'
	})

	useEffect(() => {
		const updatedName = user?.name && !isEmailLike(user.name) ? user.name : ''
		setState({
			name: updatedName,
			phone_number: user?.phone_number,
			timezone: user?.timezone,
			loading: false,
			error: null,
			step: 'confirmation'
		})
	}, [user])

	if (!isAuthenticated) {
		loginWithRedirect({
			appState: {
				returnTo: window.location.pathname + window.location.search
			}
		})
		return <></>
	}

	const onNext = async () => {
		if (!state.name) {
			return
		}

		setState({ ...state, loading: true })

		try {
			await Users.updateProfile({
				name: state.name,
				phone_number: state.phone_number?.startsWith('+')
					? state.phone_number
					: `+${state.phone_number}`,
				timezone: state.timezone || null,
				country: state.country || null,
				confirm_user: true
			})

			await userStore.initUser()

			const pendingInviteCode = getPendingInviteCode()
			if (pendingInviteCode) {
				return navigate(`/join-workspace?code=${pendingInviteCode}`)
			}

			const userInvite = await Users.getUserAccessInviteCode()
			if (userInvite?.code) {
				return navigate(`/join-workspace?code=${userInvite.code}`)
			}
			if (accounts.length === 0) {
				if (f === 'agency') {
					navigate('/start/agency')
				} else {
					navigate('/start/standard')
				}
			}
			if (
				accounts[0]?.status === 'SETUP' &&
				accounts[0].setup?.step !== 'ACCOUNT_CREATED' &&
				accounts[0].setup?.step !== 'PLAN_SELECTED'
			) {
				navigate(`/setup/${accounts[0].id}`)
			}

			setState({ ...state, loading: false })
		} catch (err: any) {
			setState({ ...state, error: parseError(err) })
		}
	}

	if (!user) {
		return <GLoading />
	}

	return (
		<ConfirmUserView
			user={user}
			state={state}
			onNext={onNext}
			setName={(s) => setState({ ...state, name: s })}
			setPhone={(s) => setState({ ...state, phone_number: s })}
			setTimezone={(s) => setState({ ...state, timezone: s })}
		/>
	)
}
